import React from 'react';
import PropTypes from 'prop-types';

// import ThemeContext from '../../../config/themeContext';

export default function AdSkip({ adVideo }) {
  // const theme = useContext(ThemeContext);

  const labelText = 'Saltar';
  function handlerClick() {
    adVideo.skip();
  }

  return (
    <div className="tpx-ext-skip" onClick={handlerClick}>
      <span className="tpx-ext-skip-text">{labelText}</span>
    </div>
  );
}

AdSkip.propTypes = {
  adVideo: PropTypes.object.isRequired,
};
